var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-card',[_c('VisitFilter',{on:{"search":_vm.search}})],1),_c('v-card',[_c('Dashboard',{ref:"dashboard",attrs:{"form":_vm.form}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }